<template>
  <v-app>
    <v-toolbar app>
      <v-toolbar-title class="headline text-uppercase">
        <span>WOW</span>
        <span class="font-weight-light">ARENA</span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn
        flat
        to="/classes"
      >
        <span class="mr-2">Classes</span>
      </v-btn>
      <v-btn
        flat
        target="_blank"
      >
        <span class="mr-2">Guides</span>
      </v-btn>
    </v-toolbar>


    <v-content>
      <router-view></router-view>
    </v-content>
  </v-app>
</template>

<script>
import HelloWorld from './components/HelloWorld'

export default {
  name: 'App',
  components: {
    HelloWorld
  },
  data () {
    return {
      //
    }
  },
  mounted() {
    this.$store.dispatch('loadClasses');
  }
}
</script>
